import { ShieldCheck, Trash2, Loader2, ArrowUpCircle, ArrowDownCircle } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

function DeleteUserButton({ u, onDelete }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="text-muted-foreground transition-colors hover:text-red-400" data-testid={`admin-delete-user-${u.email}`}>
          <Trash2 className="h-4 w-4" />
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="border-[#1E2638] bg-[#0F141C]">
        <AlertDialogHeader>
          <AlertDialogTitle>Supprimer cet utilisateur ?</AlertDialogTitle>
          <AlertDialogDescription>
            {u.email}, ses profils matériel, favoris et avis seront définitivement supprimés. Cette action est irréversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={() => onDelete(u.id)} className="bg-red-600 hover:bg-red-700" data-testid="admin-confirm-delete">Supprimer</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

function RoleButton({ u, onRole }) {
  const admin = u.role === "admin";
  const Icon = admin ? ArrowDownCircle : ArrowUpCircle;
  return (
    <button onClick={() => onRole(u.id, admin ? "user" : "admin")} title={admin ? "Rétrograder en utilisateur" : "Promouvoir administrateur"}
      className={`text-muted-foreground transition-colors ${admin ? "hover:text-amber-400" : "hover:text-violet-400"}`}
      data-testid={`admin-${admin ? "demote" : "promote"}-${u.email}`}>
      <Icon className="h-4 w-4" />
    </button>
  );
}

function UserRow({ u, self, onDelete, onRole }) {
  return (
    <tr className="border-b border-[#1E2638]/60 last:border-0" data-testid={`admin-user-row-${u.email}`}>
      <td className="px-5 py-3 font-mono2 text-xs">{u.email}</td>
      <td className="px-3 py-3">{u.name}</td>
      <td className="px-3 py-3">
        <span className={`rounded px-2 py-0.5 font-mono2 text-[10px] uppercase ${u.role === "admin" ? "bg-violet-950/60 text-violet-400" : "bg-slate-800 text-slate-400"}`}>{u.role}</span>
      </td>
      <td className="px-3 py-3">{u.mfa_enabled ? <ShieldCheck className="h-4 w-4 text-emerald-400" /> : <span className="text-muted-foreground">—</span>}</td>
      <td className="px-3 py-3 font-mono2 text-xs">{u.profiles}</td>
      <td className="px-3 py-3 text-right">
        {self ? <span className="font-mono2 text-[10px] text-muted-foreground">vous</span> : (
          <div className="flex items-center justify-end gap-2">
            <RoleButton u={u} onRole={onRole} />
            <DeleteUserButton u={u} onDelete={onDelete} />
          </div>
        )}
      </td>
    </tr>
  );
}

export function AdminUsersTable({ users, fetching, meId, onDelete, onRole }) {
  return (
    <div className="overflow-hidden rounded-xl border border-[#1E2638] bg-[#0F141C]">
      <div className="flex items-center justify-between border-b border-[#1E2638] px-5 py-3">
        <h2 className="font-head text-base font-bold">Utilisateurs</h2>
        {fetching && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#1E2638] text-left font-mono2 text-xs uppercase tracking-wide text-muted-foreground">
              <th className="px-5 py-3">E-mail</th>
              <th className="px-3 py-3">Nom</th>
              <th className="px-3 py-3">Rôle</th>
              <th className="px-3 py-3">MFA</th>
              <th className="px-3 py-3">Profils</th>
              <th className="px-3 py-3 text-right">Action</th>
            </tr>
          </thead>
          <tbody data-testid="admin-users-table">
            {users.map((u) => <UserRow key={u.id} u={u} self={u.id === meId} onDelete={onDelete} onRole={onRole} />)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
